import React from 'react'; //  { useState, useEffect }
import { Grid } from 'ldrs/react';
import 'ldrs/react/Grid.css';
const Loader = ({ bgColor }) => {
  return (
    <div
      className={`flex items-center justify-center fixed z-[9999999] h-screen w-full ${bgColor || 'bg-[#121316]'}`}
    >
      <Grid
        size={60}
        speed={1.5}
        color="rgb(238,43,42)"
        style={{ zIndex: '9999999' }}
      />
    </div>
  );
};

export default Loader;
